export default class JobReview {
    constructor (query) {
        if (!query) return;

        const form = document.querySelector(query);
        if (!form) return;

        this.rating = form.querySelector('[data-type="rating"]');

        this.init();
    }

    init () {
        const items = this.rating.querySelectorAll('.site-field--rating');
        if (!items || !items.length) return;

        [...items].forEach((item, index) => {
            const input = item.querySelector('input');
            if (!input) return;

            input.addEventListener('change', () => {
                [...items].forEach((el) => el.classList.remove('checked'));

                if (input.checked) {
                    for (let i = 0; i <= index; i++) {
                        items[i].classList.add('checked');
                    }
                }
            });
        });
    }
}